import * as React from 'react';
import { Modal, ModalFooter, ModalHeader } from 'reactstrap';
import { getValue } from '@utils/lodash';
import InfoSvgComponent from '@assets/svg-components/info';
import InputField from '@common/InputRuleFeild';

interface IConfirmModalProps {
  isOpen: boolean;
  handleModal: () => void;
  handleSubmit: () => void;
  formInfo?: any;
}

const ConfirmModal = (props: any) => {
  const checkExceptionApprovalRequired = () => {
    const formInfo = getValue(props, `formInfo`, {});
    const submittedAt = getValue(formInfo, `submitted_at`, '');
    const expenseEntries = getValue(formInfo, `expense_entries`, []);
    const exceptionLimit = getValue(
      formInfo,
      `created_by.policy.exception_approval_required_days_limit`,
      null,
    );

    if (!submittedAt || expenseEntries.length === 0) {
      return { isExceeded: false, daysLimit: exceptionLimit };
    }

    const submittedDate = new Date(submittedAt);

    for (const entry of expenseEntries) {
      const expenseDate = getValue(entry, `expense_date`, '');
      if (expenseDate) {
        const expenseDateObj = new Date(expenseDate);
        const daysDifference = Math.floor(
          (submittedDate.getTime() - expenseDateObj.getTime()) /
            (1000 * 60 * 60 * 24),
        );

        if (exceptionLimit && daysDifference > exceptionLimit) {
          return { isExceeded: true, daysLimit: exceptionLimit };
        }
      }
    }

    return { isExceeded: false, daysLimit: exceptionLimit };
  };

  const { isExceeded, daysLimit } = checkExceptionApprovalRequired();
  const submitStatus = getValue(props, `submitStatus`, '');
  const isExceptionallyApproved = getValue(
    props,
    `formInfo.is_exceptionally_approved`,
    false,
  );
  const shouldShowExceptionLogic =
    isExceeded && submitStatus === 'approve' && !isExceptionallyApproved;
  const modalTitle =
    submitStatus === 'sent-back'
      ? 'Send Back to User'
      : submitStatus === 'reject'
        ? 'Reject'
        : submitStatus === 'undo-sent-back'
          ? 'Undo Send Back'
          : 'Confirm';
  const submitButtonText =
    submitStatus === 'undo-sent-back' ? 'Undo' : 'Submit';

  return (
    <Modal
      isOpen={getValue(props, `isOpen`, '')}
      //   toggle={handleModal}
    >
      <ModalHeader style={{ background: '#f8f8fd' }}>
        <div className="d-flex align-items-center w-100">
          <InfoSvgComponent size={28} color={'#FD9933'} />
          <h6 className="header_text__18 ms-2">{modalTitle}</h6>
        </div>
      </ModalHeader>
      <div className="m-3">
        {/* {getValue(props, `submitStatus`, "") !== "reject" && (
          <h6 className="header_text__17">
            Are you sure you want to continue?
          </h6>
        )} */}
        {submitStatus === 'undo-sent-back' && (
          <h6 className="header_text__17">Are you sure you want to undo?</h6>
        )}

        {shouldShowExceptionLogic && (
          <div
            className="mb-3 p-3"
            style={{
              backgroundColor: '#f8d7da',
              border: '1px solid #f5c6cb',
              borderRadius: '4px',
            }}
          >
            <div className="d-flex align-items-center">
              <InfoSvgComponent size={24} color={'#dc3545'} />
              <span className="ms-2 text-danger small_text__14">
                This report crossed the {daysLimit} days limit, needs
                exceptional approval, please enter proper comments
              </span>
            </div>
          </div>
        )}

        {shouldShowExceptionLogic && (
          <div className="mb-3">
            <div className="d-flex align-items-center">
              <input
                type="checkbox"
                id="exceptionApproval"
                checked={true}
                disabled={true}
                className="me-2"
              />
              <label
                htmlFor="exceptionApproval"
                className="small_text__14 mb-0"
              >
                Exception approval
              </label>
            </div>
          </div>
        )}

        {(submitStatus === 'reject' ||
          submitStatus === 'approve' ||
          submitStatus === 'sent-back') && (
          <div className="mt-3">
            <p className="small_text__14 mb-1">Reason</p>
            <InputField
              inputType="TEXTAREA"
              name={'rejectComments'}
              onChange={(e: any) =>
                props.setComment(
                  e.target.value.length < 1000
                    ? e.target.value
                    : getValue(props, `comment`, ''),
                )
              }
              value={getValue(props, `comment`, '')}
              placeholder={'Enter Reason'}
            />
          </div>
        )}
      </div>
      <ModalFooter>
        <div className="delete-popup-wrapper__cta-wrapper">
          <button
            onClick={() => {
              props.handleModal();
            }}
            className="delete-popup-wrapper__cta-btn delete-popup-wrapper__cta-btn--secondary"
          >
            Cancel
          </button>
          <button
            className="delete-popup-wrapper__cta-btn delete-popup-wrapper__cta-btn--primary"
            onClick={props.handleSubmit}
            disabled={props.submitLoading}
          >
            {props.submitLoading ? 'Please wait...' : submitButtonText}
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmModal;
